var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagFrance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagFrance_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagFrance_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagFrance_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagFrance_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagFrance_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323E95",
    d: "M3.5 45h14.341V2H3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M16.817 45h14.342V2H16.817z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80031",
    d: "M31.159 45H45.5V2H31.159z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0idTdxOHRldHN3YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJhbHg4cG1pM3piIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3U3cTh0ZXRzd2EiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiN1N3E4dGV0c3dhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjYWx4OHBtaTN6YikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iIzMyM0U5NSIgZD0iTTAgNDNMMTQuMzQxIDQzIDE0LjM0MSAwIDAgMHoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMuNSAyKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGNEY0RjQiIGQ9Ik0xMy4zMTcgNDNMMjcuNjU5IDQzIDI3LjY1OSAwIDEzLjMxNyAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy41IDIpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Q4MDAzMSIgZD0iTTI3LjY1OSA0M0w0MiA0MyA0MiAwIDI3LjY1OSAweiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy41IDIpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlagFrance as ReactComponent };